export var HEADER_NAVIGATION_MENU_CONTENT_CLASS_PREFIX = 'HeaderNavigationMenuContent';
export var headerNavigationMenuContentRoot = 'HeaderNavigationMenuContentRoot';